import api from '../../../lib/api';
import type { SoaControlItem, SoaListResponse, UpdateSoaControlPayload } from './types';

export interface ListSoaParams {
  theme?: string;
  applicability?: string;
  implementationStatus?: string;
  search?: string;
}

export const fetchSoaControls = async (params: ListSoaParams = {}): Promise<SoaListResponse> => {
  const { data } = await api.get<SoaListResponse>('soa', { params });
  return data;
};

export const updateSoaControl = async (
  id: string,
  payload: UpdateSoaControlPayload,
): Promise<Partial<SoaControlItem>> => {
  const { data } = await api.put<Partial<SoaControlItem>>(`soa/${id}`, payload);
  return data;
};

export const exportSoa = async () => {
  const { data } = await api.get('soa/export');
  return data;
};
